import React, { Component } from 'react'
import { Spin, Icon, Form, Button } from 'antd'
import CKEditor from 'ckeditor4-react';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getTC, updateTC } from '../../../../core/actions/tccontents';

const antIcon = <Icon type="loading" style={{ fontSize: 50 }} spin />

class TermsCondition extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      content: '',
      reserve: '',
      newContent: ''
    }
  }

  componentDidMount() {
    this.props.getTC()
  }

  componentWillReceiveProps(nextProps) {
    let { tcContent, loading, tcContentSuccess } = nextProps
    if (tcContent.content.length > 0) {
      this.setState({
        content: tcContent.content,
        reserve: tcContent.content
      })
    }
    this.setState({
      loading: loading
    })
    if (tcContentSuccess.length > 0) {
      this.props.getTC()
    }
  }

  resetContent = () => {
    const { reserve } = this.state
    this.setState({
      newContent: reserve
    })
  }

  updateContent = () => {
    const { newContent } = this.state
    let tcPef = {
      content: newContent
    }
    this.props.updateTC(tcPef)
  }

  render() {
    const { loading, content, newContent } = this.state
    return (
      <div className="pp-form">
        <Spin spinning={loading} indicator={antIcon}>
          <Form>
            {/* <Form.Item label="Post Content" /> */}
            <CKEditor
              onBeforeLoad={(CKEditor) => (CKEditor.disableAutoInline = true)}
              data={newContent || content}
              config={{
                toolbar: [['Source', 'Format', 'Link', 'Unlink', 'NumberedList', 'BulletedList', 'Blockquote', 'Indent', 'Outdent' ]],
                height: 350,
                format_tags: 'p;h3'
              }}
              onChange={(evt) => {
                this.setState({
                  newContent: evt.editor.getData()
                });
              }}
            />
            <Form.Item className="button-holder">
              <Button type="primary" onClick={(e) => this.updateContent()}>
                Update
              </Button>
              <Button className="reset-btn" onClick={(e) => this.resetContent()}>
                Reset
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  tcContent: state.tcContents.tcContent,
  loading: state.tcContents.loading,
  tcContentSuccess: state.tcContents.tcContentSuccess,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getTC,
  updateTC
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TermsCondition)
